<script setup lang="ts">
import { BeamAnalysisWorkItemDto } from '@/api/generator';
import FormLabel from '@/components/FormLabel/FormLabel.vue';
import NamedGroup from '@/components/NamedGroup/NamedGroup.vue';
import { useSupportSystemGroups } from '@/views/jobConfigurations/utils/useSupportSystemGroups';
import { computed } from 'vue';
import { useJobOccurrence } from '../utils/useJobOccurrence';
import BeamAnalysisQaGroup from './workItems/beamAnalysis/BeamAnalysisQaGroup.vue';

/**
 * Beam analysis work item in the job execution. For now only the QA equipment
 * is shown, grouped as in the task setup, with the zero measurement reachable
 * from the interface/array pair. Instruction, work steps and the analysis
 * itself follow once the backend can run a beam analysis measurement.
 */
const props = defineProps<{
  workitem: BeamAnalysisWorkItemDto;
}>();

const { supportSystems: allSupportSystems, jobOccurrence, targetSystem } = useJobOccurrence();

const { supportSystemGroups, numGroups } = useSupportSystemGroups(
  computed(() => props.workitem.supportSystemIds ?? undefined),
  computed(() => allSupportSystems.value ?? undefined),
);
</script>

<template>
  <v-row v-if="numGroups">
    <v-col cols="12">
      <FormLabel class="mb-2" :label="$t('DosimetryAndQaEquipment')">
        <NamedGroup :groups="supportSystemGroups">
          <template #default="group">
            <BeamAnalysisQaGroup
              :systems="group.items"
              :jobOccurrenceId="jobOccurrence.id"
              :targetSystemName="targetSystem?.name ?? undefined"
              class="mt-2"
            />
          </template>
        </NamedGroup>
      </FormLabel>
    </v-col>
  </v-row>
</template>
